import * as types from './board.types';
import * as constants from './board.constants';
import { generateResourceReducer } from '../../generators/resource.reducer';

export const boardReducer = generateResourceReducer<types.IBoard>({
  STORE: constants.STORE_BOARD,
  CLEAR: constants.CLEAR_BOARD,
});
